import React from "react";
import {
    Box,
    Typography,
    Grid,
    Paper,
    Stack,
} from "@mui/material";
import ForestIcon from "@mui/icons-material/Forest";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import ParkIcon from "@mui/icons-material/Park";

const features = [
    {
        icon: <ForestIcon fontSize="large" sx={{ color: "#2e7d32" }} />,
        title: "Eco-Friendly",
        description: "We prioritize sustainability and eco-conscious farming practices in every product we offer.",
    },
    {
        icon: <SupportAgentIcon fontSize="large" sx={{ color: "#2e7d32" }} />,
        title: "24/7 Support",
        description: "Our plant experts are here to help you any time, any day, with all your gardening questions.",
    },
    {
        icon: <ParkIcon fontSize="large" sx={{ color: "#2e7d32" }} />,
        title: "Healthy Plants",
        description: "We provide the healthiest and most vibrant plants, grown with love and care.",
    },
];

const WhyChooseUs = () => {
    return (
        <Box sx={{ py: 8, px: 3, textAlign: "center" }}>
            <Typography
                className="about-us-title"
                sx={{ fontSize: { xs: '1.5rem', md: '2.5rem' } }}
                component="h1"
            >
                Why Choose Us
            </Typography>

            <Typography
                variant="subtitle1"
                sx={{ maxWidth: 700, mx: "auto", mb: 5, color: "#728675" , marginTop:"2rem"}}
            >
                Discover what makes us your go-to destination for all things green and growing.
            </Typography>

            <Grid container spacing={4} justifyContent="center">
                {features.map((feature, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index} sx={{ display: "flex" }}>
                        <Paper
                            elevation={3}
                            sx={{
                                backgroundColor: "#679267",
                                p: 3,
                                borderRadius: 4,
                                flexGrow: 1,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                transition: "transform 0.3s",
                                "&:hover": {
                                    transform: "translateY(-5px)",
                                    boxShadow: 6,
                                },
                            }}
                        >
                            <Stack spacing={2} alignItems="center" flexGrow={1}>
                                {feature.icon}
                                <Typography
                                    variant="h6"
                                    fontWeight="bold"
                                    fontFamily="Century Gothic"
                                    sx={{ color: "white" }}
                                >
                                    {feature.title}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    fontFamily="Century Gothic"
                                    textAlign="center"
                                >
                                    {feature.description}
                                </Typography>
                            </Stack>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default WhyChooseUs;
